<template>
  <div class="pageStyle">
    <div class="pageBox">
      <div class="content" id="contentBox">
        <!-- 顶部固定显示 -->
        <div class="userIsQuestionFlag">
          <!-- 展开历史记录 -->
          <img
            class="expandHistoryBtn"
            @click="toggleHistoryModal"
            src="https://static.xchengtech.cn/cc19b6904c114143a0daf80072948f18.png"
            alt=""
          />
          <!-- 企业logo -->
          <img
            class="companyLogo"
            :src="depName ? depConfig[depName].icon : depConfig['zysz'].icon"
            alt=""
          />

          <!-- 模型选择按钮 -->
          <!-- <div class="model-select-btn" @click="showModelSelectModal = true">
            <img v-if="getCurrentModelIcon" :src="getCurrentModelIcon" alt="" />
            <span>{{ selectedModelName }}</span>
          </div> -->
        </div>

        <!-- 模型选择弹窗 -->
        <van-popup
          v-model="showModelSelectModal"
          position="center"
          :overlay="true"
          :close-on-click-overlay="true"
          class="modelSelectPopup"
        >
          <div class="modelSelectContent">
            <div class="modelSelectHeader">
              <h3>选择模型</h3>
            </div>
            <div class="modelSelectBody">
              <div
                v-for="(model, index) in modelOptions"
                :key="index"
                class="modelItem"
                :class="{ selected: selectedModel === model.value }"
                @click="selectModel(model)"
              >
                <div class="modelItemContent">
                  <img :src="model.icon" alt="" />
                  <span>{{ model.label }}</span>
                </div>

                <van-icon
                  v-if="selectedModel === model.value"
                  name="success"
                  color="#3d80eb"
                />
              </div>
            </div>
          </div>
        </van-popup>
        <div class="content-box">
          <div v-for="(item, index) in talkList" :key="index">
            <!-- 机器人回答 -->
            <div v-if="item.type == 'AI'" class="robotMsgStyle item">
              <!-- 时间 -->
              <!-- <div class="time">
                <span>{{ item.time }}</span>
              </div> -->
              <!-- 回答 -->
              <div class="label">
                <!-- ai机器人头像 -->
                <!-- <img
                  src="https://static.xchengtech.cn/ba66119e180b4d3b8373d965bb162883.png"
                  alt=""
                /> -->
                <span class="labelTxtBox">
                  <!-- 回答内容 -->
                  <div class="labelTxt" v-html="item.contents"></div>
                  <!-- loading图标 -->
                  <!-- <i v-show="item.loadingShow" class="el-icon-loading"></i> -->
                  <div v-show="item.loadingShow" class="loadingIcon">
                    <div class="loading">
                      <div></div>
                      <div></div>
                      <div></div>
                    </div>
                  </div>
                  <!-- 三角形图标 -->
                  <!-- <img
                    class="triangle"
                    src="https://static.xchengtech.cn/90ffe1b744d747be86b7750a29e91cc8.png"
                    alt=""
                  /> -->
                </span>
                <!-- 评价 -->
                <!-- <div v-show="item.id">
                  <div class="evaluate" v-show="item.toEvaluateShow">
                    <span>回答是否准确？</span>
                    <span @click="toEvaluate(item.id, 'good')"
                      >准确<img src="./img/good.png" alt=""
                    /></span>
                    <span @click="toEvaluate(item.id, 'bad')"
                      >不准确<img src="./img/bad.png" alt=""
                    /></span>
                  </div>
                  <div v-show="item.evaluateTxt" class="evaluateTxt">
                    {{ item.evaluateTxt }}
                  </div>
                </div> -->
              </div>
            </div>
            <!-- 我的提问 -->
            <div v-if="item.type == 'USER'" class="myMsgStyle item">
              <!-- 时间 -->
              <!-- <div class="time">
                <span>{{ item.time }}</span>
              </div> -->
              <!-- 文件信息显示区域 -->
              <div v-if="item.file" class="file-info-container-box">
                <div class="file-info-container">
                  <div class="file-icon">
                    <img
                      :src="getFileTypeIcon(item.file)"
                      :alt="item.file.type || '文件'"
                    />
                  </div>
                  <div class="file-info">
                    <div class="file-name">{{ item.file.name }}</div>
                    <div class="file-details">
                      <span class="file-size">{{
                        formatFileSize(item.file.size)
                      }}</span>
                      <span class="file-type">{{
                        formatFileType(item.file.type, item.file.name)
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 回答 -->
              <div class="label">
                <!-- 回答内容 -->
                <span v-html="item.contents"></span>
                <!-- <img
                  src="https://static.xchengtech.cn/f754386cacbd41c98b29903b4ae71c11.png"
                  alt=""
                /> -->
                <!-- 三角形图标 -->
                <!-- <img
                  class="triangle"
                  src="https://static.xchengtech.cn/2cc09bf5260645b793d51229f1eea9d6.png"
                  alt=""
                /> -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="footer">
        <!-- 快捷选项 -->
        <div class="shortcuts">
          <!-- 绩效通 -->
          <div
            class="item shortcutsItem"
            @click="
              toUrl(
                'https://hpmra.xchengtech.cn/#/jxt?channelId=eb750ee04a834b1ca6839aedda60f54d'
              )
            "
          >
            <img
              src="https://static.xchengtech.cn/a0787508c9944627ad5e1fdf007db7c7.png"
              alt=""
            />
            <span>绩效通</span>
          </div>
          <!-- 更多服务 -->
          <div
            class="item shortcutsItem"
            @click="toUrl('https://hpmra.xchengtech.cn/#/enterpriseServices?channelId=eb750ee04a834b1ca6839aedda60f54d')"
          >
            <img
              src="https://static.xchengtech.cn/d615bc925db441828fe35224b79cd852.png"
              alt=""
            />
            <span>更多服务</span>
          </div>
          <!-- 文件解析 -->
          <!-- <div class="item">
            <div class="uploadBtn">
              <fileUploader @file-uploaded="handleFileUploaded"></fileUploader>
            </div>
          </div> -->
        </div>
        <!-- 问答框 -->
        <div class="inputBox">
          <!-- 文件信息显示区域 -->
          <div v-if="selectedFile" class="file-info-container">
            <div class="file-icon">
              <img
                :src="getFileTypeIcon(selectedFile)"
                :alt="selectedFile.type || '文件'"
              />
            </div>
            <div class="file-info">
              <div class="file-name">{{ selectedFile.name }}</div>
              <div class="file-details">
                <span class="file-size">{{
                  formatFileSize(selectedFile.size)
                }}</span>
                <span class="file-type">{{
                  formatFileType(selectedFile.type, selectedFile.name)
                }}</span>
              </div>
            </div>
            <div class="remove-file" @click="removeFile">×</div>
          </div>
          <van-field
            v-model="question"
            center
            placeholder="请输入您的问题..."
            rows="1"
            autosize
            type="textarea"
            :border="false"
          >
            <!-- @keyup.enter="onInput" -->
            <!-- <template #button> </template> -->
          </van-field>
          <div class="onInputIcon">
            <!-- 机器人回答时显示loading -->
            <van-loading v-if="answeringFlag" color="#000000" />
            <!-- 机器人未回答时显示提交按钮 -->
            <img
              v-else
              src="https://static.xchengtech.cn/843efa247c5e453898374fc9a83961ba.png"
              alt=""
              @click="onInput"
            />
          </div>
        </div>
      </div>

      <!-- 历史记录弹窗 -->
      <van-popup
        v-model="showHistoryModal"
        position="left"
        :width="'70vw'"
        :overlay="true"
        :close-on-click-overlay="true"
        class="historyPopup"
      >
        <div class="historyModalContent">
          <div class="userHeader">
            <div class="userHeader-left">
              <img :src="wxUserInfo.headimgurl" alt="" />
              <span>{{ wxUserInfo.nickname }}</span>
            </div>
            <div class="closeBtn" @click="showHistoryModal = !showHistoryModal">
              <img
                src="https://static.xchengtech.cn/3e9aa99268dd40e78dcdf7a35c3098b1.png"
                alt=""
              />
            </div>
          </div>
          <div class="historyModalHeader">
            <h3>历史对话</h3>
          </div>
          <div class="historyModalBody">
            <div v-if="historyRecords.length === 0" class="noHistory">
              <p>暂无历史对话记录</p>
            </div>
            <div v-else class="historyList">
              <div
                v-for="(record, index) in historyRecords"
                :key="index"
                class="historyItem"
                :class="{ historyItemChoice: selectedHistoryIndex === index }"
                @click="selectHistoryRecord(record, index)"
              >
                <img
                  class="historyItemIcon"
                  src="https://static.xchengtech.cn/569d6a2225c94292837d169ecd045e24.light"
                  alt=""
                />
                <div class="historyItemTitle">{{ record.label }}</div>
                <!-- <div class="historyItemTime">{{ record.date }} {{ record.time }}</div> -->
              </div>
            </div>
          </div>
        </div>
      </van-popup>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Loading, Toast, Field, Uploader, Icon, Popup, Button } from "vant";
import { marked } from "marked";
import { getHistoryList, getUserConversation } from "@/api/robot";
import { simpleUuid } from "@/utils/index";
import hljs from "highlight.js";
import Cookies from "js-cookie";
import "highlight.js/styles/github.css";
import { getWx } from "@/utils/wxJsSdk.js";
import fileUploader from "./fileUploader";
Vue.use(Loading);
Vue.use(Field);
Vue.use(Uploader);
Vue.use(Icon);
Vue.use(Popup);
Vue.use(Button);
export default {
  components: { fileUploader },
  watch: {},
  data() {
    return {
      fileList: [],
      // 选中的文件信息
      selectedFile: null,
      // 图片文件的DataURL，用于直接显示图片作为图标
      imageDataURL: null,
      // 对话记录
      talkList: [
        // {
        //   type: "AI",
        //   contents: "欢迎咨询，请输入您想查询的问题~",
        //   time: this.getNowTime(),
        // },
      ],
      // 用户提问内容
      question: "",
      // 结果集文字 原始数据
      answerTxt: "",
      // 回答中的标识
      answeringFlag: false,
      answerId: 0,
      sseId: "",
      // 机器人状态
      robotSstatus: "随时为您解答各种问题",
      // 标签状态：记录未完整闭合的Markdown标签
      incompleteTags: {
        codeBlock: false, // 是否处于未闭合的代码块（```开头未结尾）
        bold: 0, // 加粗标签数量（** 成对为0，单数为未闭合）
        italic: 0, // 斜体标签数量（* 成对为0，单数为未闭合）
        heading: false, // 是否处于未完整的标题（# 后未接空格/文本未结束）
        list: false, // 是否处于未完整的列表（-/*/1. 后未接文本）
      },
      uploadFileUUid: "",
      questionId: simpleUuid(),
      // 历史记录弹窗控制
      showHistoryModal: false,
      // 当前选中的历史记录索引
      selectedHistoryIndex: -1,
      depConfig: {
        hpmra: {
          icon: "https://static.xchengtech.cn/8b7751e5e818402fbc4f9ffee0540bec.png",
          title: "绩效AI",
          desc: "专注于绩效管理的智能AI助手",
          shareIcon:
            "https://static.xchengtech.cn/351a2943ba9b48bc8209037a8f28d5df.png",
        },
        zysz: {
          icon: "https://static.xchengtech.cn/54455a10f2924454a9adc56d28faf399.png",
          shareIcon:
            "https://static.xchengtech.cn/54455a10f2924454a9adc56d28faf399.png",
          title: "AI机器人",
          desc: "专注于提供智能问答服务的AI助手",
        },
      },
      historyRecords: [],
      // 选中的模型
      selectedModel: "deepseek",
      // 当前选中的模型名称
      selectedModelName: "DeepSeek",
      // 模型选择
      modelOptions: [
        {
          label: "DeepSeek",
          value: "deepseek",
          icon: "https://static.xchengtech.cn/f99cc9eabb8e47808e7810bb8a3c7ec0.png",
        },
        {
          label: "豆包AI",
          value: "douBao",
          icon: "https://static.xchengtech.cn/adce94974a364ef4b14d0a020d3406a5.png",
        },
        {
          label: "通义千问",
          value: "qwen",
          icon: "https://static.xchengtech.cn/e5136a7703334a5b868fff65919a96be.png",
        },
      ],
      depName: "",
      wxUserInfo: {},
      // 模型选择弹窗控制
      showModelSelectModal: false,
    };
  },
  created() {
    // 获取部门名称
    let query = this.$route.query;
    if (query.depName) {
      this.depName = query.depName;
    } else {
      this.depName = "zysz";
    }
    // 获取微信分享配置
    this.getShareTxt();
  },
  computed: {
    // 获取当前选中模型的图标
    getCurrentModelIcon() {
      if (!this.selectedModel) return "";
      const model = this.modelOptions.find(
        (item) => item.value === this.selectedModel
      );
      return model ? model.icon : "";
    },
  },
  mounted() {
    // 解析查询参数 -》 获取微信用户信息 -> 获取用户历史记录
    this.getQury();
    // 初始化
    this.toInit();
    // 初始化footer高度监测
    this.initFooterHeightMonitor();

    // 测试语句
    // let body = {
    //   type: "AI",
    //   contents: "我是DeepSeek助手！我是一个专门为您提供产品信息查询服务的AI助手。",
    //   time: this.getNowTime(),
    //   loadingShow: false,
    //   evaluateTxt: "",
    //   answerId: this.answerId,
    //   toEvaluateShow: false,
    // };
    // this.talkList.push(body);
  },
  beforeDestroy() {
    // 销毁ResizeObserver实例
    if (this.footerResizeObserver) {
      this.footerResizeObserver.disconnect();
    }
  },

  methods: {
    getShareTxt() {
      let desc = this.depConfig[this.depName].desc;
      let title = this.depConfig[this.depName].title;
      let imgUrl = this.depConfig[this.depName].shareIcon;
      let link =
        "https://wx1.xchengtech.cn/saas/getUserInfo?destination=code&depName=zysz&url=" +
        encodeURIComponent(window.location.href);
      console.log("link", link);
      getWx(this.depName).then((res) => {
        window.wx.updateAppMessageShareData({
          title: title, // 分享标题
          desc: desc, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: imgUrl, // 分享图标
          success: function (res) {
            console.log("res", res);
            //afterShare();
          },
        });
      });
    },
    // 获取用户历史会话
    getHistoryList(openId) {
      getHistoryList(openId).then((res) => {
        // 按照createDateTime字段倒序排序（最新的在前面）
        this.historyRecords = res.sort((a, b) => {
          return new Date(b.createDateTime) - new Date(a.createDateTime);
        });

        console.log("this.historyRecords", this.historyRecords);
      });
    },
    // 判断是否有token参数
    getQury() {
      // 1.检查wxUserInfo 没有则重定向至微信环境
      this.wxUserInfo = Cookies.get("wxUserInfo");

      if (!this.wxUserInfo) {
        let url = encodeURIComponent(window.location.href);
        window.location.href =
          "https://wx1.xchengtech.cn/saas/getUserInfo?destination=code&depName=zysz&url=" +
          url;
        return false;
      }

      this.wxUserInfo = JSON.parse(this.wxUserInfo);
      this.getHistoryList(this.wxUserInfo.openid);
    },
    // 切换历史记录弹窗显示
    toggleHistoryModal() {
      this.showHistoryModal = !this.showHistoryModal;
      this.getHistoryList(this.wxUserInfo.openid);
    },
    // 选择历史记录
    selectHistoryRecord(record, index) {
      console.log("record", record);
      // 停止机器人当前回答
      this.answeringFlag = true;
      this.answerTxt = "";

      // 重置标签状态
      this.incompleteTags = {
        codeBlock: false,
        bold: 0,
        italic: 0,
        heading: false,
        list: false,
      };

      this.selectedHistoryIndex = index;
      this.talkList = [];
      getUserConversation(this.wxUserInfo.openid, record.conversationId)
        .then((res) => {
          // 从第三条开始遍历（跳过前两条，索引从0开始）
          res.slice(3).forEach((item) => {
            if (item.type === "AI") {
              // 对AI回答进行Markdown格式化
              const formattedContent = marked(item.text, {
                highlight: (code, lang) => {
                  const validLang = hljs.getLanguage(lang) ? lang : "plaintext";
                  return hljs.highlight(code, { language: validLang }).value;
                },
                tables: true,
                breaks: true,
                gfm: true,
              });
              this.talkList.push({
                type: "AI",
                contents: formattedContent,
              });
            }
            if (item.type === "USER") {
              this.talkList.push({
                type: "USER",
                contents: item.contents[0].text,
              });
            }
          });
          this.answeringFlag = false;
          this.toWindowBottom();
          this.questionId = record.conversationId;
        })
        .catch(() => {
          this.answeringFlag = false;
        });
    },
    // 跳转链接
    toUrl(url) {
      const toast = Toast.loading({
        duration: 0, // 持续展示 toast
        forbidClick: true,
        message: "加载中",
        overlay: true,
      });
      // 延迟一小段时间后跳转，让用户看到加载提示
      setTimeout(() => {
        toast.close();
        window.location.href = url;
      }, 300);
    },
    // 初始化
    toInit() {
      // 添加欢迎语
      this.getWelcomeTxt();
    },

    // 移除选中的文件
    removeFile() {
      this.selectedFile = null;
      console.log("文件已移除");
    },

    // 处理文件上传完成事件
    handleFileUploaded(fileInfo) {
      this.selectedFile = fileInfo;
      console.log("文件上传完成:", fileInfo);
    },

    // 格式化文件大小
    formatFileSize(bytes) {
      if (bytes === 0) return "0 B";
      const k = 1024;
      const sizes = ["B", "KB", "MB", "GB"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
    },

    // 格式化文件类型，显示更简洁的名称
    formatFileType(type, fileName) {
      if (!type && !fileName) return "未知类型";

      // 先尝试从文件名后缀获取
      if (fileName) {
        const ext = fileName.split(".").pop().toLowerCase();
        const typeMap = {
          jpg: "JPG",
          jpeg: "JPEG",
          png: "PNG",
          gif: "GIF",
          pdf: "PDF",
          doc: "Word",
          docx: "Word",
          ppt: "PPT",
          pptx: "PPT",
          xls: "Excel",
          xlsx: "Excel",
          txt: "文本",
          md: "Markdown",
          csv: "CSV",
          json: "JSON",
          epub: "EPUB",
          mobi: "MOBI",
          bmp: "BMP",
        };
        if (typeMap[ext]) {
          return typeMap[ext];
        }
      }

      // 如果后缀匹配不到，尝试从MIME类型获取
      if (type) {
        if (type.startsWith("image/")) {
          return "图片";
        } else if (type.includes("pdf")) {
          return "PDF";
        } else if (type.includes("word") || type.includes("doc")) {
          return "Word";
        } else if (type.includes("powerpoint") || type.includes("ppt")) {
          return "PPT";
        } else if (
          type.includes("excel") ||
          type.includes("spreadsheet") ||
          type.includes("xls")
        ) {
          return "Excel";
        } else if (type.includes("text")) {
          return "文本";
        }
      }

      return "未知类型";
    },

    // 根据文件类型获取对应的图标
    getFileTypeIcon(file) {
      if (!file) return "";

      const fileName = file.name.toLowerCase();
      const fileType = file.type;

      // 图片类型 - 使用文件本身的URL作为缩略图
      if (
        fileName.endsWith(".jpg") ||
        fileName.endsWith(".jpeg") ||
        fileName.endsWith(".png") ||
        fileName.endsWith(".gif") ||
        fileName.endsWith(".bmp")
      ) {
        return (
          file.url ||
          "https://static.xchengtech.cn/45751f8b169f4e688e150b064df5b384.png"
        );
      }

      // PDF文档
      if (fileName.endsWith(".pdf")) {
        return "https://static.xchengtech.cn/3d62b857b8e942ae9b329454180dd15b.png";
      }

      // Word文档
      if (fileName.endsWith(".doc") || fileName.endsWith(".docx")) {
        return "https://static.xchengtech.cn/b96c9238b8ff497395a1c203963edabb.png";
      }

      // PPT文档
      if (fileName.endsWith(".ppt") || fileName.endsWith(".pptx")) {
        return "https://static.xchengtech.cn/5b6d9175d0be4b87802bd3049064559e.png";
      }

      // Excel文档
      if (fileName.endsWith(".xls") || fileName.endsWith(".xlsx")) {
        return "https://static.xchengtech.cn/ef23847a427546d09e81b274e159ff31.png";
      }

      // 文本文件
      if (
        fileName.endsWith(".txt") ||
        fileName.endsWith(".md") ||
        fileName.endsWith(".csv") ||
        fileName.endsWith(".json")
      ) {
        return "https://static.xchengtech.cn/8706da78764f42118084d5cf281ba1f5.png";
      }

      // ePub和mobi文件
      if (fileName.endsWith(".epub") || fileName.endsWith(".mobi")) {
        return "https://static.xchengtech.cn/45751f8b169f4e688e150b064df5b384.png";
      }

      // 默认文件图标
      return "https://static.xchengtech.cn/45751f8b169f4e688e150b064df5b384.png";
    },

    onInput() {
      // 如果正在回答
      if (this.answeringFlag) {
        alert("机器人正在回答问题，请稍等");
        return false;
      }
      // 如果机器人没有正在回答，并且有提问内容
      if (this.question) {
        // 添加用户提问问题
        this.userAddQuestions();
        // 添加机器人回答对象
        this.robotAnswer();
        // 把当前聊天定位到聊天框最下面
        this.toWindowBottom();
        // 打开正在回答结束开关
        this.answeringFlag = true;
        // 调用提问接口
        this.toQuestion();
      } else {
        alert("请输入需要提问的问题");
        return false;
      }
    },
    // 提问方法
    async toQuestion() {
      this.answerTxt = "";
      this.answeringFlag = true;
      const question = this.question;
      this.question = "";
      this.toWindowBottom();

      // 新增：标签缓冲字符（暂存未完整标签的字符）
      let tagBuffer = "";
      const typeSpeed = 50;

      // 测试环境
      // let apiUrl = "http://8.138.185.207:4091/";
      // 正式环境
      let apiUrl = "https://aiapi.xchengtech.cn/";

      // 请求方式 openid+questionId
      try {
        // 构建请求体
        const requestBody = {
          question: question,
          model: this.selectedModel,
        };

        // 只有当selectedFile存在时，才添加file字段
        if (this.selectedFile) {
          requestBody.file = this.selectedFile.url;
        }

        const res = await fetch(
          `${apiUrl}xcChat/v2/pm/${this.wxUserInfo.openid}:${this.questionId}`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(requestBody),
          }
        );
        if (!res.ok) throw new Error("请求失败");

        const reader = res.body.getReader();
        const decoder = new TextDecoder("utf-8");

        while (true) {
          // 检查是否需要停止回答
          if (!this.answeringFlag) {
            await reader.cancel();
            // 更新最后一个回答项的状态
            const s = this.talkList.find(
              (item) => item.answerId === this.answerId
            );
            if (s) s.loadingShow = false;
            break;
          }

          const { done, value } = await reader.read();
          if (done) {
            // 处理最后剩余的标签缓冲（强制按普通文本显示）
            if (tagBuffer) {
              this.answerTxt += tagBuffer;
              tagBuffer = "";
              this.renderMd();
              this.toWindowBottom();
            }
            // 结束状态更新
            const s = this.talkList.find(
              (item) => item.answerId === this.answerId
            );
            if (s) s.loadingShow = false;
            this.answeringFlag = false;
            this.answerId++;
            this.toWindowBottom();
            break;
          }

          // 解码当前流数据，追加到标签缓冲
          tagBuffer += decoder.decode(value, { stream: true });
          // 检查标签缓冲是否包含“可安全处理的片段”（每积累1-2个字符检查一次，平衡流畅度和准确性）
          while (tagBuffer.length >= 2 || (done && tagBuffer.length > 0)) {
            // 检查是否需要停止回答
            if (!this.answeringFlag) {
              await reader.cancel();
              // 更新最后一个回答项的状态
              const s = this.talkList.find(
                (item) => item.answerId === this.answerId
              );
              if (s) s.loadingShow = false;
              break;
            }

            // 临时拼接缓冲字符，判断是否有完整标签
            const tempCheck = this.processIncompleteText(tagBuffer);
            const safeLength = tempCheck.length;

            if (safeLength > 0) {
              // 有可安全解析的字符：追加到answerTxt，清空对应长度的缓冲
              this.answerTxt += tagBuffer.slice(0, safeLength);
              tagBuffer = tagBuffer.slice(safeLength);
              // 渲染并等待
              this.renderMd();
              this.toWindowBottom();
              await new Promise((resolve) => setTimeout(resolve, typeSpeed));
            } else {
              // 无安全字符：退出循环，等待更多字符
              break;
            }
          }

          // 再次检查是否需要停止回答
          if (!this.answeringFlag) {
            await reader.cancel();
            // 更新最后一个回答项的状态
            const s = this.talkList.find(
              (item) => item.answerId === this.answerId
            );
            if (s) s.loadingShow = false;
            break;
          }
        }
      } catch (err) {
        // 错误处理（原有逻辑保留）
        const s = this.talkList.find((item) => item.answerId === this.answerId);
        console.log("s", s);
        if (s) {
          s.loadingShow = false;
          s.contents =
            "<span style='color:#ff4d4f;'>回答加载失败，请重试~</span>";
        }
        this.answerId++;
        this.answeringFlag = false;
        console.error("请求错误：", err);
      }
    },

    // 辅助方法：批量逐字符渲染（处理最后剩余缓存）
    typeCharByChar(text, speed) {
      return new Promise((resolve) => {
        let index = 0;
        const timer = setInterval(() => {
          if (index < text.length) {
            this.answerTxt += text[index];
            this.renderMd();
            this.toWindowBottom();
            index++;
          } else {
            clearInterval(timer);
            resolve();
          }
        }, speed);
      });
    },
    // 渲染md
    renderMd() {
      // 1. 先用标签缓冲逻辑处理文本，得到“可安全解析的文本”
      const safeText = this.processIncompleteText(this.answerTxt);

      // 2. 原有：处理不完整语法（可选保留，双重保障）
      let completeTxt = safeText;
      const incompleteRules = {
        codeBlock: (txt) => txt, // 已通过processIncompleteText处理，无需再修改
        list: (txt) => txt,
        heading: (txt) => txt,
      };
      Object.values(incompleteRules).forEach(
        (rule) => (completeTxt = rule(completeTxt))
      );

      // 3. 原有：Markdown解析+代码高亮
      const s = this.talkList.find((item) => item.answerId === this.answerId);
      if (s) {
        s.contents = marked(completeTxt, {
          highlight: (code, lang) => {
            const validLang = hljs.getLanguage(lang) ? lang : "plaintext";
            return hljs.highlight(code, { language: validLang }).value;
          },
          tables: true, // 显式开启表格支持
          breaks: true,
          gfm: true,
        });
      }
      this.$nextTick(() => {
        this.toWindowBottom();
      });
    },
    // 处理未完整的Markdown文本，返回“可安全解析的文本”
    processIncompleteText(rawText) {
      let processedText = rawText;
      const tags = this.incompleteTags;

      // 1. 处理代码块（``` 成对才闭合）
      const codeBlockCount = (processedText.match(/```/g) || []).length;
      tags.codeBlock = codeBlockCount % 2 !== 0; // 单数=未闭合
      if (tags.codeBlock) {
        // 未闭合：截取到最后一个 ``` 之前的内容，后面的暂存
        const lastCodeBlockIndex = processedText.lastIndexOf("```");
        processedText = processedText.slice(0, lastCodeBlockIndex + 3); // 保留最后一个 ```（避免下次重复识别）
      }

      // 2. 处理加粗（** 成对才闭合）
      const boldCount = (processedText.match(/\*\*/g) || []).length;
      tags.bold = boldCount % 2;
      if (tags.bold) {
        // 未闭合：移除最后一个未配对的 **
        processedText = processedText.replace(/\*\*$/, "");
      }

      // 3. 处理斜体（* 成对才闭合，且排除代码块内的 *）
      if (!tags.codeBlock) {
        // 代码块内的 * 不视为斜体标签
        const italicCount = (processedText.match(/\*/g) || []).length;
        tags.italic = italicCount % 2;
        if (tags.italic) {
          processedText = processedText.replace(/\*$/, "");
        }
      }

      // 4. 处理标题（# 后必须接空格+文本，且到换行前才算完整）
      const headingMatch = processedText.match(/#+\s+.+$/); // 匹配完整标题（如 # 标题）
      tags.heading = !headingMatch && processedText.match(/#+\s?$/); // 未接文本=未完整
      if (tags.heading) {
        // 未完整：移除 # 符号（避免解析为错误标题）
        processedText = processedText.replace(/#+\s?$/, "");
      }

      // 5. 处理列表（-/*/1. 后接文本才算完整，到换行前）
      const listMatch = processedText.match(/([\n\r])([-*]|\d+\.)\s+.+$/); // 完整列表项
      tags.list = !listMatch && processedText.match(/([\n\r])([-*]|\d+\.)\s?$/); // 未接文本=未完整
      if (tags.list) {
        // 未完整：移除列表前缀（如 - 、1. ）
        processedText = processedText.replace(/([\n\r])([-*]|\d+\.)\s?$/, "$1");
      }

      return processedText;
    },
    // 获取当前时间
    getNowTime() {
      let now = new Date();
      let timeString = now.toLocaleTimeString();
      let [hours, minutes, seconds] = timeString.split(":");
      return hours + ":" + minutes;
    },
    // 获取欢迎语
    getWelcomeTxt() {
      // 添加机器人回答对象
      let body = {
        type: "AI",
        contents: "",
        time: this.getNowTime(),
        loadingShow: true,
        evaluateTxt: "",
        answerId: this.answerId,
        toEvaluateShow: false,
      };
      this.talkList.push(body);
      // 获取欢迎语
      this.toQuestion();
    },
    // 添加用户提问
    userAddQuestions() {
      let body = {
        type: "USER",
        contents: this.question,
        time: this.getNowTime(),
      };

      // 如果有选中的文件，添加文件信息
      if (this.selectedFile) {
        body.file = this.selectedFile;
      }

      this.talkList.push(body);

      // 提问后清空选中的文件
      this.selectedFile = null;
    },
    // 添加机器人回答
    robotAnswer(label) {
      let body = {
        type: "AI",
        contents: "",
        time: this.getNowTime(),
        answerId: this.answerId,
        loadingShow: true,
        evaluateTxt: "",
        toEvaluateShow: true,
      };
      if (label) {
        body.contents = label;
      }
      this.talkList.push(body);
    },
    // 快捷方式
    toShortcuts(txt) {
      this.question = txt;
      this.onInput();
    },
    // 选择模型
    selectModel(modelValue) {
      this.selectedModel = modelValue.value;
      this.selectedModelName = modelValue.label;
      this.showModelSelectModal = false;
    },
    // 确认选择模型
    confirmModelSelect() {
      if (this.selectedModel) {
        // 可以在这里添加选择模型后的逻辑处理
        console.log("选中的模型:", this.selectedModel);
        this.showModelSelectModal = false;
      } else {
        Toast("请选择一个模型");
      }
    },
    // 初始化footer高度监测
    initFooterHeightMonitor() {
      const contentElement = document.querySelector(".content");
      const footerElement = document.querySelector(".footer");

      if (!contentElement || !footerElement) return;

      // 更新content的padding-bottom
      const updateContentPadding = () => {
        const footerHeight = footerElement.offsetHeight;
        contentElement.style.paddingBottom = `${footerHeight}px`; // 额外增加20px作为安全距离
      };

      // 初始化时设置一次
      updateContentPadding();

      // 使用ResizeObserver监测footer高度变化
      this.footerResizeObserver = new ResizeObserver(() => {
        updateContentPadding();
      });

      // 开始监测
      this.footerResizeObserver.observe(footerElement);
    },
    toWindowBottom() {
      this.$nextTick(() => {
        let contentBox = document.getElementById("contentBox");
        if (contentBox) {
          // 方案1：直接设置scrollTop（基础版）
          // contentBox.scrollTop = contentBox.scrollHeight;

          // 方案2：使用scrollTo（支持平滑滚动，兼容性更好）
          contentBox.scrollTo({
            top: contentBox.scrollHeight,
            behavior: "smooth", // 平滑滚动（可选，删除则为瞬间滚动）
            block: "end", // 确保底部内容完全显示
          });
        }
      });
    },
    isMorningOrAfternoon() {
      const now = new Date();
      const hours = now.getHours();
      if (hours < 12) {
        return "尊敬的用户，上午好";
      } else {
        return "尊敬的用户，下午好";
      }
    },
  },
};
</script>
<style>
table {
  width: 100%;
  /* 宽度设为父元素的100% */
  border-collapse: collapse;
  /* 边框合并，避免双线 */
  text-align: center;
}

table,
th,
td {
  border: 1px solid #ddd;
  /* 边框样式 */
  padding: 8px;
  text-align: center;
  /* 内边距 */
}

th {
  background-color: #f2f2f2;
  /* 表头背景色 */
}

hr {
  margin: 2vw 0;
}

/* 处理pre标签撑开页面宽度的问题 */
pre {
  max-width: 100%;
  overflow-x: auto;
  padding: 10px;
  text-wrap: auto;
}

/* 确保code标签在pre内也能正常显示 */
pre code {
  max-width: 100%;
  overflow-x: auto;
  white-space: pre;
}
</style>

<style  src="./index.css" scoped >
</style>


// WEBPACK FOOTER //
// src/views/robot/index.vue